export const VERTICAL_NAME = 'VISITOR_REGISTRATION';

// Pins helix/VRS adapter resolution to a specific app instance config when a
// building has more than one VISITOR_REGISTRATION integration configured.
export const APP_INSTANCE_CONFIG_UUID_HEADER = 'HqO-App-Instance-UUID';
